module.exports = __webpack_public_path__ + "static/media/sherry.83093a92.png";